import { render, staticRenderFns } from "./WorkGroupAdd.vue?vue&type=template&id=beb4ed90"
import script from "./WorkGroupAdd.vue?vue&type=script&lang=js"
export * from "./WorkGroupAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports